<h2 mat-dialog-title class="title-retour">
  Retour en arrière — {{ data.devisReference }}
</h2>

<mat-dialog-content>
  <p class="info-msg">
    Le devis sera remis en statut <strong>CRÉÉ</strong> et renvoyé au CDC pour correction.<br>
    Cette action est irréversible pour les statuts <em>Accepté</em> et <em>Refusé</em>.
  </p>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Motif du retour en arrière</mat-label>
      <textarea matInput
                formControlName="motifRetour"
                rows="5"
                placeholder="Expliquez la raison du retour (minimum 10 caractères)…">
      </textarea>
      <mat-error *ngIf="form.get('motifRetour')?.hasError('required')">
        Le motif est obligatoire
      </mat-error>
      <mat-error *ngIf="form.get('motifRetour')?.hasError('minlength')">
        Le motif doit contenir au moins 10 caractères
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="saving">Annuler</button>
  <button mat-raised-button color="accent"
          [disabled]="saving"
          (click)="onConfirmer()">
    <mat-spinner *ngIf="saving" diameter="16" class="btn-spinner"></mat-spinner>
    Retour en arrière
  </button>
</mat-dialog-actions>
